import BasicRouterView from "../../../components/BasicRouterView.vue";

const estoque = {
  path: "etq",
  redirect: { name: "salvos" },
  meta: {
    label: "Estoque",
    icon: "storage",
    show: true,
  },
  component: BasicRouterView,
  children: [
    {
      path: "estoque/estoque-posicoes",
      name: "estoque-posicoes",
      meta: {
        label: "POSIÇÕES",
        icon: "settings",

        show: true,
      },
      component: () =>
        import(/* webpackChunkName: "pdt" */ "../estoque/views/Posicoes.vue"),
    },
    {
      path: "estoque/estoque-transferencia",
      name: "estoque-transferencia",
      meta: {
        label: "TRANSF POSIÇÃO",
        icon: "settings",

        show: true,
      },
      component: () =>
        import(
          /* webpackChunkName: "pdt" */ "../estoque/views/Transferencia.vue"
        ),
    },
    {
      path: "estoque/estoque-upload",
      name: "estoque-upload",
      meta: {
        label: " UPLOAD ATIVAR CONTROLE",
        icon: "settings",

        show: true,
      },
      component: () =>
        import(/* webpackChunkName: "pdt" */ "../estoque/views/Upload.vue"),
    },
    {
      path: "estoque/relatorio-estoque-consolidado",
      name: "relatorio-estoque-consolidado",
      meta: {
        label: "RELATÓRIO CONSOLIDADO",
        icon: "summarize",

        show: true,
      },
      component: () =>
        import(
          /* webpackChunkName: "pdt" */ "../estoque/views/RelatorioConsolidado.vue"
        ),
    },
  ],
};

export default estoque;
